<template>
  <b-modal
    id="active-search-modal"
    ref="modal"
    title="Pending User Invites"
    size="xl"
  >
    <div v-if="invites && invites.length">
      <pending-user-table :items="invites" />
    </div>

    <div v-else>
      <p>You do not have any pending user invites right now.</p>
    </div>

    <template
      slot="modal-footer"
    >
      <button
        class="btn"
        @click="hide()"
      >
        Dismiss
      </button>
    </template>
  </b-modal>
</template>

<script>
import PendingUserTable from '@/components/tables/PendingUserTable.vue';
export default {
  name: 'ViewPendingUsersModal',
  components: {
    PendingUserTable,
  },
  props: {
    invites: {
      type: Array,
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
